import axios from 'axios';
import { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import core from '../../core';
import { Pagination, Stack } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { notificationActions } from "../../data/notification";
import { Search, ThreeDotsVertical, Plus } from 'react-bootstrap-icons';
import OutsideClickHandler from 'react-outside-click-handler';
import { Button, Modal } from 'react-bootstrap';
import AddNewTransaction from './AddNewTransaction';
import useViewMode from '../../hooks/useViewMode';
import ViewToggle from '../../components/DataView/ViewToggle';
import DataCards from '../../components/DataView/DataCards';
import useT from '../../i18n/useT';

const Transactions = () => {
    const t = useT();
    const [filter, setFilter] = useState({limit: 10, page: 1, keyword: "", asc: "desc", start_date: "", end_date: "", sort_by: "id"})
    const [transactions, setTransactions] = useState([]);
    const [paginator, setPaginator] = useState({from: 0, to: 0, total: 0, pages: 1});
    const [loading, setLoading] = useState(false);
    const [showTransactionModal, setShowTransactionModal] = useState(false);
    const [formData, setFormData] = useState({user_id: "", vin: "", mark: "", model: "", year: "", buyer: "", personal_number: "", paid_amount: "", payment_type: ''})
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.user.language);
    const [createdTransactionsCount, setCreatedTransactionsCount] = useState(0);
    const [loadingCreateTransaction, setLoadingCreateTransaction] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [actionsId, setActionsId] = useState("");
    const [actionType, setActionType] = useState("add");
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const {view, setView, isMobile} = useViewMode("transactions-view");

    const rowActions = (transaction) => (
        <div className='table-actions-block'>
            <ThreeDotsVertical height={"19px"} onClick={() => setActionsId(transaction.id)} style={{cursor: "pointer"}}/>
            {actionsId === transaction.id && <OutsideClickHandler onOutsideClick={() => setActionsId("")}>
                <div className='table-actions-dropdown'>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setActionType("edit");
                        setFormData({user_id: transaction.payer,...transaction});
                        setShowTransactionModal(true);
                    }}>{t("common.edit")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setFormData({...transaction});
                        setShowConfirmationModal(true);
                    }}>{t("common.delete")}</div>
                </div>
            </OutsideClickHandler>}
        </div>
    );

    const cardFields = [
        {label: t("transactions.payedId"), value: (tx) => tx.payer},
        {label: t("transactions.date"), value: (tx) => tx.create_date != null ? core.formdatDate(tx.create_date, "yyyy-mm-dd hr:min") : t("table.notDefined")},
        {label: t("transactions.vin"), value: (tx) => tx.vin},
        {label: t("transactions.mark"), value: (tx) => tx.mark},
        {label: t("transactions.model"), value: (tx) => tx.model},
        {label: t("transactions.year"), value: (tx) => tx.year},
        {label: t("transactions.personalNumber"), value: (tx) => tx.personal_number},
        {label: t("transactions.amount"), value: (tx) => tx.paid_amount},
        {label: t("transactions.paymentType"), value: (tx) => tx.payment_type},
    ];

    const handlers = {
        createTransaction(e){
            e.preventDefault();
            setLoadingCreateTransaction(true);
            axios.post('/api/transactions', formData)
                .then((res) => {
                    setShowTransactionModal(false);
                    setLoadingCreateTransaction(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedTransactionsCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateTransaction(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        modifyTransaction(e){
            e.preventDefault();
            setLoadingCreateTransaction(true);
            axios.put(`/api/transactions/${formData.id}`, formData)
                .then((res) => {
                    setLoadingCreateTransaction(false);
                    setShowTransactionModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedTransactionsCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateTransaction(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        deleteTransaction(){
            setLoadingCreateTransaction(true);
            axios.delete(`/api/transactions/${formData.id}`)
                .then((res) => {
                    setLoadingCreateTransaction(false);
                    setShowConfirmationModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedTransactionsCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateTransaction(false);
                    setShowConfirmationModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        }
    }

    useEffect(() => {
        setLoading(true);
        axios.get(`/api/transactions?limit=${filter.limit}&page=${filter.page}&keyword=${filter.keyword}&asc=${filter.asc}&start_date=${filter.start_date}&end_date=${filter.end_date}&sort_by=${filter.sort_by}`)
            .then((res) => {
                setLoading(false);
                setTransactions(res.data.data);
                const fromItems = ((filter.page - 1) * filter.limit) + 1;
                const toItems = res.data.total < filter.page * filter.limit ? res.data.total :  filter.page * filter.limit;
                const pagesCount = res.data.total % filter.limit === 0 ? res.data.total / filter.limit : parseInt((res.data.total / filter.limit) + 1);
                setPaginator({from: fromItems, to: toItems, total: res.data.total, pages: pagesCount});
            })
            .catch((err) => {

            })
    }, [filter, createdTransactionsCount]);

    return(
        <div className="page-content-main-container">
            <h2 className="page-title">{t("transactions.title")}</h2>
            <div className="table-filter-container">
                <button className='btn btn-primary' style={{display: "flex", alignItems: "center", marginRight: "15px"}} onClick={() => {
                    setShowTransactionModal(true);
                    setFormData({user_id: "", vin: "", mark: "", model: "", year: "", buyer: "", personal_number: "", paid_amount: "", payment_type: ""});
                    setActionType("add");
                }}><Plus style={{fontSize: "20px", fontWeight: "bold"}} /> <span>{t("common.addNew")}</span></button>
                <ViewToggle view={view} setView={setView} isMobile={isMobile} />
                <div className='search-by-keyword'>
                    <input placeholder={t("common.search")} type='text' onKeyDown={(e) => {
                        if(e.keyCode === 13){
                            setFilter((prev) => ({...prev, keyword: keyword}));
                        }
                    }} value={keyword} className='form-control' onChange={(e) => setKeyword(e.target.value)} />
                    <button onClick={() => setFilter((prev) => ({...prev, keyword: keyword}))}><Search /></button>
                </div>
            </div>
            {view === "table" ? (
            <Table responsive>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>{t("transactions.payedId")}</th>
                        <th>{t("transactions.date")}</th>
                        <th>{t("transactions.vin")}</th>
                        <th>{t("transactions.mark")}</th>
                        <th>{t("transactions.model")}</th>
                        <th>{t("transactions.year")}</th>
                        <th>{t("transactions.personalNumber")}</th>
                        <th>{t("transactions.amount")}</th>
                        <th>{t("transactions.paymentType")}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading && <tr><td colSpan={10}><div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><div className="loader" role=""></div></div></td></tr>
                    }
                    {
                        (transactions.length > 0 && !loading) && transactions.map((transaction) => {
                            return(
                                <tr key={transaction.personal_number}>
                                    <td>{transaction.id}</td>
                                    <td>{transaction.payer}</td>
                                    <td>{transaction.create_date != null ? core.formdatDate(transaction.create_date, "yyyy-mm-dd hr:min") : t("table.notDefined")}</td>
                                    <td>{transaction.vin}</td>
                                    <td>{transaction.mark}</td>
                                    <td>{transaction.model}</td>
                                    <td>{transaction.year}</td>
                                    <td>{transaction.personal_number}</td>
                                    <td>{transaction.paid_amount}</td>
                                    <td>{transaction.payment_type}</td>
                                    <td>{rowActions(transaction)}</td>
                                </tr>
                            )
                        })
                    }
                    {
                        (!loading && transactions.length === 0) && <tr><td colSpan={10} style={{textAlign: "center"}}>{t("table.notFound")}</td></tr>
                    }
                </tbody>
            </Table>
            ) : (
                <DataCards layout={view}
                    items={loading ? [] : transactions}
                    loading={loading}
                    getKey={(t) => t.personal_number}
                    renderTitle={(t) => t.id}
                    renderSubtitle={(t) => t.vin}
                    fields={cardFields}
                    renderActions={(t) => rowActions(t)}
                />
            )}
            <div className="pagination-container">
                <div className="paginatior-left-size">
                    <p className="showing-items-text">{t("table.showing")} {paginator.from} {t("table.of")} {paginator.to}</p>
                    <span style={{margin: "0 12px"}}>{t("table.total")}: {paginator.total}</span>
                    <span>{t("table.show")}:</span>
                    <select value={filter.limit} onChange={(e) => setFilter((prev) => ({...prev, limit: e.target.value}))} className="form-control" style={{width: "50px"}}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={50}>50</option>
                    </select>
                </div>
                <Stack spacing={2}>
                    <Pagination count={paginator.pages} page={filter.page} onChange={(value, p) => setFilter((prev)=>({...prev, page: p}))} />
                </Stack>
            </div>
            {showTransactionModal && <AddNewTransaction show={showTransactionModal} setShow={setShowTransactionModal} formData={formData} setFormData={setFormData} submit={actionType === "add" ? handlers.createTransaction : handlers.modifyTransaction} loading={loadingCreateTransaction} type={actionType}/>}
            <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} >
                <Modal.Header closeButton><h3>{t("transactions.removeTitle")}</h3></Modal.Header>
                <Modal.Body><p>{t("transactions.removeConfirm")}</p></Modal.Body>
                <Modal.Footer>
                    <Button type='button' onClick={handlers.deleteTransaction} variant={loadingCreateTransaction ? 'secondary' : 'primary'} disabled={loadingCreateTransaction}>{loadingCreateTransaction ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : t("common.yes")}</Button>
                    <Button type='button' onClick={() => setShowConfirmationModal(false)} variant='danger'>{t("common.no")}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Transactions